// @core/api/endpoints/secret/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CreateDatabaseRole } from './create_database_role';
import { CreateEncryptionKey } from './create_encryption_key';
import { CreatePkiRole } from './create_pki_role';
import { CreatePolicy } from './create_policy';
import { Decrypt } from './decrypt';
import { DeleteDatabaseRole } from './delete_database_role';
import { DeleteEncryptionKey } from './delete_encryption_key';
import { DeleteKvSecret } from './delete_kv_secret';
import { DeletePkiRole } from './delete_pki_role';
import { DeletePolicy } from './delete_policy';
import { DestroyKvSecretVersions } from './destroy_kv_secret_versions';
import { Encrypt } from './encrypt';
import { GenerateCredentials } from './generate_credentials';
import { GenerateDataKey } from './generate_data_key';
import { GenerateIntermediate } from './generate_intermediate';
import { GenerateRandomBytes } from './generate_random_bytes';
import { GenerateRoot } from './generate_root';
import { GetCA } from './get_ca';
import { GetCRL } from './get_crl';
import { GetCertificate } from './get_certificate';
import { GetDatabaseRole } from './get_database_role';
import { GetEncryptionKey } from './get_encryption_key';
import { GetEngine } from './get_engine';
import { GetKvSecret } from './get_kv_secret';
import { GetKvSecretMetadata } from './get_kv_secret_metadata';
import { GetPkiRole } from './get_pki_role';
import { GetPolicy } from './get_policy';
import { GetSealStatus } from './get_seal_status';
import { Health } from './health';
import { Initialize } from './initialize';
import { IssueCertificate } from './issue_certificate';
import { ListAuditEntries } from './list_audit_entries';
import { ListCertificates } from './list_certificates';
import { ListDatabaseRoles } from './list_database_roles';
import { ListEncryptionKeys } from './list_encryption_keys';
import { ListEngines } from './list_engines';
import { ListKvSecrets } from './list_kv_secrets';
import { ListLeases } from './list_leases';
import { ListPkiRoles } from './list_pki_roles';
import { ListPolicies } from './list_policies';
import { MountEngine } from './mount_engine';
import { PutKvSecret } from './put_kv_secret';
import { RenewLease } from './renew_lease';
import { RevokeCertificate } from './revoke_certificate';
import { RevokeLease } from './revoke_lease';
import { Rewrap } from './rewrap';
import { RotateEncryptionKey } from './rotate_encryption_key';
import { Seal } from './seal';
import { Sign } from './sign';
import { SignIntermediate } from './sign_intermediate';
import { TuneEngine } from './tune_engine';
import { UndeleteKvSecretVersions } from './undelete_kv_secret_versions';
import { UnmountEngine } from './unmount_engine';
import { Unseal } from './unseal';
import { UpdateEncryptionKeyConfig } from './update_encryption_key_config';
import { UpdateKvSecretMetadata } from './update_kv_secret_metadata';
import { UpdatePolicy } from './update_policy';
import { Verify } from './verify';

// Re-export individual endpoints
export {
  CreateDatabaseRole,
  CreateEncryptionKey,
  CreatePkiRole,
  CreatePolicy,
  Decrypt,
  DeleteDatabaseRole,
  DeleteEncryptionKey,
  DeleteKvSecret,
  DeletePkiRole,
  DeletePolicy,
  DestroyKvSecretVersions,
  Encrypt,
  GenerateCredentials,
  GenerateDataKey,
  GenerateIntermediate,
  GenerateRandomBytes,
  GenerateRoot,
  GetCA,
  GetCRL,
  GetCertificate,
  GetDatabaseRole,
  GetEncryptionKey,
  GetEngine,
  GetKvSecret,
  GetKvSecretMetadata,
  GetPkiRole,
  GetPolicy,
  GetSealStatus,
  Health,
  Initialize,
  IssueCertificate,
  ListAuditEntries,
  ListCertificates,
  ListDatabaseRoles,
  ListEncryptionKeys,
  ListEngines,
  ListKvSecrets,
  ListLeases,
  ListPkiRoles,
  ListPolicies,
  MountEngine,
  PutKvSecret,
  RenewLease,
  RevokeCertificate,
  RevokeLease,
  Rewrap,
  RotateEncryptionKey,
  Seal,
  Sign,
  SignIntermediate,
  TuneEngine,
  UndeleteKvSecretVersions,
  UnmountEngine,
  Unseal,
  UpdateEncryptionKeyConfig,
  UpdateKvSecretMetadata,
  UpdatePolicy,
  Verify,
};

// Namespace export for convenient usage
export const secretApi = {
  CreateDatabaseRole,
  CreateEncryptionKey,
  CreatePkiRole,
  CreatePolicy,
  Decrypt,
  DeleteDatabaseRole,
  DeleteEncryptionKey,
  DeleteKvSecret,
  DeletePkiRole,
  DeletePolicy,
  DestroyKvSecretVersions,
  Encrypt,
  GenerateCredentials,
  GenerateDataKey,
  GenerateIntermediate,
  GenerateRandomBytes,
  GenerateRoot,
  GetCA,
  GetCRL,
  GetCertificate,
  GetDatabaseRole,
  GetEncryptionKey,
  GetEngine,
  GetKvSecret,
  GetKvSecretMetadata,
  GetPkiRole,
  GetPolicy,
  GetSealStatus,
  Health,
  Initialize,
  IssueCertificate,
  ListAuditEntries,
  ListCertificates,
  ListDatabaseRoles,
  ListEncryptionKeys,
  ListEngines,
  ListKvSecrets,
  ListLeases,
  ListPkiRoles,
  ListPolicies,
  MountEngine,
  PutKvSecret,
  RenewLease,
  RevokeCertificate,
  RevokeLease,
  Rewrap,
  RotateEncryptionKey,
  Seal,
  Sign,
  SignIntermediate,
  TuneEngine,
  UndeleteKvSecretVersions,
  UnmountEngine,
  Unseal,
  UpdateEncryptionKeyConfig,
  UpdateKvSecretMetadata,
  UpdatePolicy,
  Verify,
};
